import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useCompleteQuiz } from '@/query/queries/quiz/useCompleteQuiz';
import { APP_LINKS } from '@/helpers/links';
import { Preloader } from '@/components/Preloader';

const QuizCompletePage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const { mutateAsync: completeQuiz } = useCompleteQuiz();

  useEffect(() => {
    const finishQuiz = async () => {
      const anonymousId = searchParams.get('anonymousId');
      if (anonymousId) {
        try {
          await completeQuiz({ slug, anonymousId });
        } catch (e) {
          console.error('Quiz completion failed', e);
        }
      } else {
        console.error('Quiz completion: missing anonymousId query param');
      }
      navigate(APP_LINKS.auth, { replace: true });
    };
    finishQuiz();
  }, [slug, searchParams, completeQuiz, navigate]);

  return (
    <div style={{ height: '100vh' }}>
      <Preloader />
    </div>
  );
};

export default QuizCompletePage;
